import { Controller } from "@hotwired/stimulus";
// This needs to be refactored later
export default class extends Controller {
  static targets = ["iconDown", "iconRight", "toggleLink", "content", "section", "toggle"];

  toggle() {
    const expanded = this.toggleLinkTarget.getAttribute('aria-expanded') === 'true';
    this.toggleLinkTarget.setAttribute('aria-expanded', (!expanded).toString());

    this.iconDownTargets.forEach((el) => el.classList.toggle( "d-none", expanded));
    this.iconRightTargets.forEach((el) => el.classList.toggle( "d-none", !expanded));

    // Toggle individual content sections
    this.contentTargets.forEach((el) => {
      if (el.classList.contains('collapse') && !el.classList.contains('show')) {
        el.classList.add('show');
      } else {
        el.classList.remove('show');
      }
    });
  }

  toggleAll() {
    const allExpanded = this.hasExpandedSection();

    this.sectionTargets.forEach((section) => {
      if (allExpanded) {
        // If any section is expanded, close all
        section.classList.remove('show');
        section.classList.add('collapse');
      } else {
        // If no sections are expanded, expand all
        section.classList.remove('collapse');
        section.classList.add('show');
      }
    });

    this.toggleLinkTargets.forEach((toggleLink) => {
      toggleLink.setAttribute('aria-expanded', (!allExpanded).toString());
    });
    this.updateIcons(!allExpanded);
  }

  hasExpandedSection() {
    return this.sectionTargets.some((section) => section.classList.contains('show'));
  }

  updateIcons(expanded) {
    this.iconDownTargets.forEach((el) => el.classList.toggle( "d-none", expanded));
    this.iconRightTargets.forEach((el) => el.classList.toggle( "d-none", !expanded));
  }
}
